import React from 'react';

export const VonageContext = React.createContext(null);
